<template>
    <div>
        <multiselect
            v-model="selected"
            :class="validateError != '' ? 'box-border-color' : ''"
            :clear-on-select="!multiple"
            :close-on-select="!multiple"
            :deselect-label="''"
            :multiple="multiple"
            :options="options"
            :placeholder="$t('select')"
            :select-label="''"
            :selected-label="''"
            :disabled="disabled"
            label="text"
            track-by="value"
            @input="handleInput($event, multiple)"
        >
            <template slot="selection" slot-scope="{ values, search, isOpen}" v-if="multiple">
                <span v-if="values.length && !isOpen" class="multiselect__single">
	                {{ translateNSelected(values) }}
                </span>
            </template>
            <span slot="noOptions">{{ $t('no_options') }}</span>
            <span slot="noResult">{{ $t('no_result') }}</span>
        </multiselect>
        <span class="invalid-feedback-custom" v-show="validateError" v-html="validateError"/>
    </div>
</template>

<script>
    // Helpers
    import translateNSelected from '@/helpers/translateNSelected';
    import handleInput from '@/helpers/handleInput';
    import setSelected from '@/helpers/setSelected';

    export default {
        props: {
            value: {
                default: null
            },
            valueType: {
                type: String,
                default: 'id'
            },
            multiple: {
                type: Boolean,
                default: false
            },
            validateError: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value: function(newValue) {
                this.selected = this.setSelected(newValue, this.options, this.multiple)
            }
        },
        data() {
            return {
                selected: null,
                options: [
                    {value: 1, text: this.$t('class_x', {class: 1})},
                    {value: 2, text: this.$t('class_x', {class: 2})},
                    {value: 3, text: this.$t('class_x', {class: 3})},
                    {value: 4, text: this.$t('class_x', {class: 4})},
                    {value: 5, text: this.$t('class_x', {class: 5})},
                    {value: 6, text: this.$t('class_x', {class: 6})}
                ]
            }
        },
        created() {
            this.selected = this.setSelected(this.value, this.options, this.multiple)
        },
        methods: {
            translateNSelected,
            handleInput,
            setSelected
        }
    }
</script>
